import { evaluates } from './evaluates'

export function classes () {
  return evaluates('class Something {}')
}
